<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Company')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="det">
            <FloatingLabel v-model="details.uuid" label="UUID" autocomplete="false" size="sm" />

            <FloatingLabel v-model="details.name" label="Name" autocomplete="false" size="sm" />
            <FloatingLabel v-model="details.cui" label="CUI" autocomplete="false" size="sm" />
            <FloatingLabel
              v-model="details.registration_number"
              label="Registration Number"
              autocomplete="false"
              size="sm"
            />

            <FloatingLabel
              v-model="details.address"
              label="Address"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.license_number"
              label="License Number"
              autocomplete="false"
              size="sm"
            />

            <FloatingLabel
              v-model="details.ticket_footer_text"
              label="Ticket Footer"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <!-- moved to Tenant.vue
            <multiselect
              v-model="details.edefault_shop_id"
              :options="companyShopsList"
              placeholder="No default shop selected"
              track-by="eid"
              label="name"
              :translate="false"
            ></multiselect>

            <FloatingLabel
              v-model="details.auth_url"
              label="Auth URL"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.bet_url"
              label="Bet URL"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <FloatingLabel
              v-model="details.settle_url"
              label="Settle URL"
              autocomplete="false"
              type="textarea"
              size="sm"
            />
            -->

            <div style="text-align:right">
              <b-dropdown variant="success" right split :text="$t('Save')" @click="onSubmitDetails">
                <b-dropdown-item @click="saveAsNew">{{$t('Save As New')}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import Multiselect from "@/components/multiselect-filters";

export default {
  name: "company",
  props: ["selectedeid"],
  components: {
    FloatingLabel,
    Multiselect,
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
      this.newId = true;
    }

    Promise.all([
      this.$store.dispatch("cache/fetch", "tenants").catch(err => {}),
      // this.$store.dispatch("cache/fetch", "shops").catch(err => {}), // moved to Tenant.vue
    ]).finally(() => {
        this.loadData();
      });
  },

  data: function() {
    return {
      eid: "",
      details: {
        name: "",
        cui: "",
        registration_number: "",
        address: "",
        license_number: "",
        ticket_footer_text: "",
        /* // moved to Tenant.vue
        edefault_shop_id: null,
        auth_url: "",
        bet_url: "",
        settle_url: "",
        */
        uuid: ""
      },
      newId: false,

      temp: {}
    };
  },

  computed: {
    /* // moved to Tenant.vue
    companyShopsList() {
      let fulllist = this.$store.getters["cache/shops"];
      let temp = [];
      fulllist.forEach(element => {
          if (element.ecompany_id == this.eid) {
            temp.push(element);
          }
        });
      return temp;
    },
    */
  },

  methods: {
    loadData() {
      if (this.eid == "") {
        // new role; nothing to load
        return;
      }
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      this.$store
        .dispatch("company/read", this.eid)
        .then(resp => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    saveAsNew() {
      this.eid = "";
      this.newId = true;
      this.onSubmitDetails();
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));

      /* // moved to Tenant.vue
      if (detailsData.edefault_shop_id && detailsData.edefault_shop_id.eid) {
        detailsData.edefault_shop_id = detailsData.edefault_shop_id.eid
      } else {
        detailsData.edefault_shop_id = null;
      }
      */

      let apiAction = "company/update";
      if (this.newId) {
        apiAction = "company/create";
      } else {
        detailsData.eid = this.eid;
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Company updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Company created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";
      this.details.name = r.name;
      this.details.cui = r.cui;
      this.details.registration_number = r.registration_number;
      this.details.address = r.address;
      this.details.license_number = r.license_number;
      this.details.ticket_footer_text = r.ticket_footer_text;
      this.details.uuid = r.uuid;

      /* // moved to Tenant.vue
      this.details.edefault_shop_id = r.edefault_shop_id;
      this.details.auth_url = r.auth_url;
      this.details.bet_url = r.bet_url;
      this.details.settle_url = r.settle_url;
      if (this.details.edefault_shop_id) {
        this.companyShopsList.forEach(element => {
          if (element.eid == this.details.edefault_shop_id) {
            this.details.edefault_shop_id = element;
            return;
          }
        });
      }
      */

    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Company", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
